import '../css/LineBrowserGuard.css';

function LineBrowserGuard() {
  const agent = navigator.userAgent || '';
  const isAndroid = /Android/i.test(agent);
  const isLineBrowser = /Line\//i.test(agent) || (/; wv\)/i.test(agent) && /LIFF/i.test(agent));
  // iPhone/iPad ใช้งานต่อใน LINE ได้เลย ไม่บังคับคัดลอกลิงก์ไป Safari
  // Android คงขั้นตอนเปิด Chrome ภายนอกตามเดิม
  if (!isAndroid || !isLineBrowser) return null;

  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const intentUrl = `intent://${url.host}${url.pathname}${url.search}${url.hash}#Intent;scheme=${url.protocol.replace(':', '')};package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(currentUrl)};end`;

  return <div className="line-browser-guard" role="alertdialog" aria-modal="true">
    <div><span>🌐</span><h1>เปิดผ่านเบราว์เซอร์ภายนอก</h1><p>สำหรับ Android กรุณาเปิดด้วย Chrome เพื่อให้กล้อง การแจ้งเตือน และการติดตั้งแอปทำงานครบถ้วน</p><a className="line-browser-open-button" href={intentUrl}><b>👆 กดเพื่อเปิด Google Chrome</b><small>แตะปุ่มนี้เพื่อใช้งานต่อ</small></a><small>หากปุ่มไม่ทำงาน ให้กดเมนู ⋮ ใน LINE แล้วเลือก “เปิดในเบราว์เซอร์อื่น”</small></div>
  </div>;
}

export default LineBrowserGuard;
